import http from "../http";

const getAuthKey = (): string => {
  const key = process.env.REACT_APP_AUTHORIZATION_KEY;
  if (!key || key === "undefined") {
    throw new Error(
      "REACT_APP_AUTHORIZATION_KEY is not set in .env. Add the client authorization key for the token endpoint (e.g. Basic base64(clientId:clientSecret) or the key your API expects)."
    );
  }
  return key;
};

export const login = ({ username, password }: { username: string; password: string }) => {
  return http("token", {
    body: `username=${username}&password=${password}&grant_type=password`,
    headers: {
      Authorization: getAuthKey()
    },
    method: "POST"
  });
};

export const updateRefreshToken = ({ refreshToken }: { refreshToken: string | null }) => {
  return http("token", {
    body: `grant_type=refresh_token&refresh_token=${refreshToken}`,
    headers: {
      Authorization: getAuthKey()
    },
    method: "POST"
  });
};

export const getUserInfo = ({ userId, refresh = true }: { userId: number; refresh?: boolean }) => {
  return http(`api/users/${userId}`, {
    method: "GET",
    params: { refresh }
  });
};

export const getNonceToken = () => {
  return http("api/users/getNonce", {
    method: "GET"
  });
};
